import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import PrismicVue from "@prismicio/vue";
import * as VueGoogleMaps from "vue2-google-maps";

import "./assets/style/app.sass";
import { declinationOfNum } from "@/utils/declination";

Vue.config.productionTip = false;

Vue.prototype.$declination = declinationOfNum;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB0LFE9r3EhleFPLIAyzDRozoQVj0kThY0"
  }
});

Vue.use(PrismicVue, {
  endpoint: "https://lsaran-archive.cdn.prismic.io/api/v2"
});

new Vue({
  router,
  i18n,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
